import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "-7 -5 37 37",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 1.006c6.072 0 10.994 4.922 10.994 10.994S18.072 22.994 12 22.994 1.006 18.072 1.006 12 5.928 1.006 12 1.006zm7.027 5.38L6.387 19.028a8.994 8.994 0 0 0 12.64-12.64zM12 3.007a8.994 8.994 0 0 0-7.027 14.607l12.64-12.64A8.956 8.956 0 0 0 12 3.006z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }